import { get } from '../../api';
import { DefaultResponseDTO } from '../../constants';

export const getRolesRequest = (rolesType: string): Promise<DefaultResponseDTO<string[]>> => {
  return get<DefaultResponseDTO<string[]>>(`/roles/${rolesType}`);
};
